<mat-card class="card-primary" *ngIf="lang == 'esp' " style="background-color: white;">

    <mat-card-content>
        <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
            alt="logo Gofit" class="logo">
        <h2>Muchas gracias por participar</h2>
        <p>Y si quieres, accede al siguiente enlace para dejarnos tu calificación <button (click)="redirect()"> aquí
            </button> </p>
    </mat-card-content>
</mat-card>
<mat-card class="card-primary" *ngIf="lang == 'por' " style="background-color: white;">

    <mat-card-content>
        <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
            alt="logo Gofit" class="logo">
        <h2>Muito obrigado por participar.</h2>
        <p>E se quiser, aceda ao link seguinte e deixe-nos a sua avaliação<button (click)="redirect()"> aqui </button>
        </p>
    </mat-card-content>
</mat-card>
<mat-card class="card-primary" *ngIf="lang == 'eng' " style="background-color: white;">

    <mat-card-content>
        <img src="https://www.cpcesfe2.org.ar/wp-content/themes/consejo/img/logo.png" alt="" class="logo">
        <h2>Thank you very much for participating</h2>
        <p>And if you want, visit the following link to leave us your opinion.</p><a href="#"> </a>
    </mat-card-content>
</mat-card>